import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root',
})
export class OrdersEventService {
  // Search Order Panel
  private searchOrder = new BehaviorSubject<string>(null);
  public searchOrderStorage = this.searchOrder.asObservable();

  // LoadingTable
  private loadingTable = new BehaviorSubject<boolean>(null);
  public loadingTableStorage = this.loadingTable.asObservable();

  // Filters Order Panel
  private filtersOrder = new BehaviorSubject<any>(null);
  public filtersOrderStorage = this.filtersOrder.asObservable();

  // Cambiar API
  constructor(private http: HttpClient) {}

  setFilters(
    dateFilter: any,
    priceFilter: any,
    statusFilter: any,
    methodFilter: any,
    scheduleFilter?: any,
    placeFilter?: any,
  ) {
    // Renombrar scheduleFilter a sessions para que coincida con el payload esperado
    let filters = {
      dateFilter,
      priceFilter,
      statusFilter,
      methodFilter,
      sessions: scheduleFilter,
      placeFilter,
    };
    let actualValue = this.filtersOrder.getValue() || {
      searchOrder: null,
      filterOrders: null,
    };
    actualValue.filterOrders = filters;
    this.filtersOrder.next(actualValue);
  }

  setSearchOrder(searchText: string) {
    this.searchOrder.next(searchText);
    let actualValue = this.filtersOrder.getValue() || {
      searchOrder: null,
      filterOrders: null,
    };
    actualValue.searchOrder = searchText;
    this.filtersOrder.next(actualValue);
  }

  setLoadingTable(loadingTable: boolean) {
    this.loadingTable.next(loadingTable);
  }

  getReportsByBusiness(
    idBusiness: number,
    page: number,
    searchText: any,
    filtersOrders: any,
    orderFilters: any,
    idEvent: number,
    places: any,
  ) {
    let url = `${AppSettings.API_URI_V2}/companies/${idBusiness}/orders?page=${page}`;
    if (searchText) {
      url += `&search=${searchText}`;
    }
    if (idEvent) {
      url += `&id_event[]=${idEvent}`;
    }
    if (filtersOrders) {
      if (filtersOrders.dateFilter) {
        url += `&date_from=${filtersOrders.dateFilter.date_from}`;
        if (filtersOrders.dateFilter.date_to) {
          url += `&date_to=${filtersOrders.dateFilter.date_to}`;
        }
      }
      if (filtersOrders.priceFilter) {
        url += `&price_from=${filtersOrders.priceFilter.min}&price_to=${filtersOrders.priceFilter.max}`;
      }
      if (filtersOrders.statusFilter) {
        filtersOrders.statusFilter.forEach((element) => {
          url += `&id_status[]=${element}`;
        });
      }
      if (filtersOrders.methodFilter) {
        filtersOrders.methodFilter.forEach((element) => {
          url += `&id_channel[]=${element}`;
        });
      }
      if (filtersOrders.sessions) {
        filtersOrders.sessions.forEach((element) => {
          url += `&id_session[]=${element}`;
        });
      }
    }
    if (places) {
      places?.forEach((element) => {
        if (element && element != 'null') {
          url += `&id_space[]=${element}`;
        }
      });
    }
    if (orderFilters) {
      url += `&sort=${orderFilters.orderBy}:${orderFilters.order}`;
    }
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getOrdersById(idOrder: number) {
    const url = `${AppSettings.API_URI_V2}/orders/${idOrder}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getCountTickets(idEvent: number) {
    const url = `${AppSettings.API_URI_V2}/count/lines/event/${idEvent}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getFiltersState() {
    return this.filtersOrder.getValue();
  }

  clearAllFilters() {
    this.searchOrder.next(null);
    this.filtersOrder.next(null);
    this.loadingTable.next(false);
  }
}
